import Container from '@/vuepage/example/index';
import SlideshowList from '@/vuepage/slideshow/list'
import HomeList from '@/vuepage/home/list'
import BrandList from '@/vuepage/style/brand-list'
import StyleList from '@/vuepage/style/style-list'
import StoreList from '@/vuepage/store/list'
import StoreDetail from '@/vuepage/store/detail'
import StoreEdit from '@/vuepage/store/edit'
import StoreAdd from '@/vuepage/store/add'
import ProductList from '@/vuepage/product/list'
import ProductDetail from '@/vuepage/product/detail'
import ProductEdit from '@/vuepage/product/edit'
import ProductAdd from '@/vuepage/product/add'
import SlideshowDetail from '@/vuepage/slideshow/detail'
import SlideshowEdit from '@/vuepage/slideshow/edit'
import StyleDetail from '@/vuepage/style/style-detail'
import BrandDetail from '@/vuepage/style/brand-detail'
import BrandEdit from '@/vuepage/style/brand-edit'
import BrandAdd from '@/vuepage/style/brand-add'
import ContactList from '@/vuepage/about/contact-list'
import About from '@/vuepage/about/about'
import CooperateBrandList from '@/vuepage/about/cooperate-brand-list'
import Cooperation from '@/vuepage/about/cooperation'
import Buy from '@/vuepage/about/buy'
//  因为后台路由不多，直接丢在同一个文件里
//  貌似有点多，凑活了

export default [
  {
    path: '/slideshow-list',
    component: Container,
    children: [
      {
        path: '',
        component: SlideshowList,
        meta: [
          {
            name: '轮播图管理',
            url: '/slideshow-list',
          },
          {
            name: '轮播图列表',
            url: '/slideshow-list',
          },
        ],
      },
      {
        path: '/slideshow-detail/:uuid',
        component: SlideshowDetail,
        meta: [
          {
            name: '轮播图管理',
            url: '/slideshow-list',
          },
          {
            name: '轮播图列表',
            url: '/slideshow-list',
          },
        ],
      },
      {
        path: '/slideshow-edit/:uuid',
        component: SlideshowEdit,
        meta: [
          {
            name: '轮播图管理',
            url: '/slideshow-list',
          },
          {
            name: '轮播图列表',
            url: '/slideshow-list',
          },
        ],
      },
      {
        path: '/home-list',
        component: HomeList,
        meta: [
          {
            name: '首页推荐管理',
            url: '/home-list',
          },
          {
            name: '轮播图列表',
            url: '/home-list',
          },
        ],
      },
      {
        path: '/brand-list',
        component: BrandList,
        meta: [
          {
            name: '风格管理',
            url: '/style-list',
          },
          {
            name: '品牌列表',
            url: '/brand-list',
          },
        ],
      },
      {
        path: '/brand-detail/:uuid',
        component: BrandDetail,
        meta: [
          {
            name: '风格管理',
            url: '/style-list',
          },
          {
            name: '品牌列表',
            url: '/brand-list',
          },
        ],
      },
      {
        path: '/brand-edit/:uuid',
        component: BrandEdit,
        meta: [
          {
            name: '风格管理',
            url: '/style-list',
          },
          {
            name: '品牌列表',
            url: '/brand-list',
          },
        ],
      },
      {
        path: '/brand-add',
        component: BrandAdd,
        meta: [
          {
            name: '风格管理',
            url: '/style-list',
          },
          {
            name: '品牌列表',
            url: '/brand-list',
          },
        ],
      },
      {
        path: '/style-list',
        component: StyleList,
        meta: [
          {
            name: '风格管理',
            url: '/style-list',
          },
          {
            name: '风格列表',
            url: '/style-list',
          },
        ],
      },
      {
        path: '/style-detail/:uuid',
        component: StyleDetail,
        meta: [
          {
            name: '风格管理',
            url: '/style-list',
          },
          {
            name: '风格列表',
            url: '/style-list',
          },
        ],
      },
      {
        path: '/store-list',
        component: StoreList,
        meta: [
          {
            name: '体验店管理',
            url: '/store-list',
          },
          {
            name: '体验店列表',
            url: '/store-list',
          },
        ],
      },
      {
        path: '/store-detail/:uuid',
        component: StoreDetail,
        meta: [
          {
            name: '体验店管理',
            url: '/store-list',
          },
          {
            name: '体验店列表',
            url: '/store-list',
          },
        ],
      },
      {
        path: '/store-edit/:uuid',
        component: StoreEdit,
        meta: [
          {
            name: '体验店管理',
            url: '/store-list',
          },
          {
            name: '体验店列表',
            url: '/store-list',
          },
        ],
      },
      {
        path: '/store-add',
        component: StoreAdd,
        meta: [
          {
            name: '体验店管理',
            url: '/store-list',
          },
          {
            name: '体验店列表',
            url: '/store-list',
          },
        ],
      },
      {
        path: '/product-list',
        component: ProductList,
        meta: [
          {
            name: '产品管理',
            url: '/product-list',
          },
          {
            name: '产品列表',
            url: '/product-list',
          },
        ],
      },
      {
        path: '/product-detail/:uuid',
        component: ProductDetail,
        meta: [
          {
            name: '产品管理',
            url: '/product-list',
          },
          {
            name: '产品列表',
            url: '/product-list',
          },
        ],
      },
      {
        path: '/product-edit/:uuid',
        component: ProductEdit,
        meta: [
          {
            name: '产品管理',
            url: '/product-list',
          },
          {
            name: '产品列表',
            url: '/product-list',
          },
        ],
      },
      {
        path: '/product-add',
        component: ProductAdd,
        meta: [
          {
            name: '产品管理',
            url: '/product-list',
          },
          {
            name: '产品列表',
            url: '/product-list',
          },
        ],
      },
      {
        path: '/contact-list',
        component: ContactList,
        meta: [
          {
            name: '联络我们',
            url: '/contact-list',
          },
        ],
      },
      {
        path: '/about',
        component: About,
        meta: [
          {
            name: '关于IDALHome',
            url: '/about',
          },
        ],
      },
      {
        path: '/cooperate-brand-list',
        component: CooperateBrandList,
        meta: [
          {
            name: '合作品牌',
            url: '/cooperate-brand-list',
          },
        ],
      },
      {
        path: '/cooperation',
        component: Cooperation,
        meta: [
          {
            name: '战略合作',
            url: '/cooperation',
          },
        ],
      },
      {
        path: '/buy',
        component: Buy,
        meta: [
          {
            name: '如何购买',
            url: '/buy',
          },
        ],
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/routers.js